import React from 'react';
import withValidations from 'lib/hocs/withValidations';
import { handleChange } from 'lib/stores/formStore';
import { formatIdFromName } from 'lib/utility';

import FormLabel from './FormLabel';

const FormSelectField = ({ name, label, id, value, inputClass, options, required }) => (
  <div className="mb-3">
    <FormLabel id={id || formatIdFromName(name)} label={label || name} required={required} />
    <select
      name={name}
      value={value}
      onChange={handleChange}
      id={id || formatIdFromName(name)}
      data-testid={id || formatIdFromName(name)}
      required={required}
      className={inputClass}
    >
      <option value="">Select...</option>
      {options.map(([optionValue, optionLabel]) => (
        <option value={optionValue} key={optionValue}>{optionLabel || optionValue}</option>
      ))}
    </select>
  </div>
);

export default withValidations({ required: true })(FormSelectField);
